// src/i18n/index.js (REPLACE ENTIRE FILE)
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";

const STORAGE_KEY = "app_lang";

const DICT = {
  fr: {
    lang: {
      fr: "Français",
      en: "English",
    },

    home: {
      verified: "Vérifié",
      notVerified: "Non vérifié",
      officialControl: "Contrôle officiel",
    },

    // ✅ DRIVER (Home + Official Control)
    driver: {
      // Home screen (after scan)
      verified: "Vérifié",
      notVerified: "Non vérifié",
      officialControl: "Contrôle officiel",

      profileTitle: "Profil du chauffeur",
      profileSub: "Permis & CNI",
      name: "Nom du chauffeur",
      permit: "Permis de conduire",
      cni: "CNI",

      // ✅ Aliases used by DriverOfficialControlScreen.js
      capacityTitle: "Autorisation d'exercer",
      capacitySub: "Capacité",
      capacityNumber: "Numéro de capacité",
      capacityStatus: "Statut",
      capacityNotRegistered: "Non enregistré",

      // ✅ EXACT TEXT YOU WANT
      capacityAbsent: "Non Renseigné",

      capacityHelper: "Ce chauffeur ne dispose pas d'une autorisation d'exercer valide.",

      // Official control screen
      official: {
        // Card 1: Driver
        driverTitle: "Profil du chauffeur",
        driverSub: "Permis & CNI",
        permitNumber: "Numéro de permis",
        permitExpiry: "Date d'expiration du permis",
        permitStatus: "Statut du permis",

        // Card 2: Capacité
        capacityTitle: "Autorisation d'exercer",
        capacitySub: "Capacité",
        capacityNumber: "Numéro de capacité",
        capacityExpiry: "Date d'expiration",
        capacityStatus: "Statut",

        // ✅ Reusable keys (recommended)
        notRegistered: "Non enregistré",
        notApplicable: "Non applicable",

        // ✅ EXACT TEXT YOU WANT
        absent: "Non Renseigné",

        // ✅ Backward-compat keys (keep)
        capacityMissingNumber: "Non enregistré",
        capacityMissingExpiry: "Non applicable",
        capacityAbsentStatus: "Non Renseigné",

        capacityAbsentHelper:
          "Ce chauffeur ne dispose pas d'une autorisation d'exercer valide.",
      },
    },

    modal: {
      enterSecretCode: "Entrer le code secret",
      placeholder: "••••••",
      wrongCode: "Code incorrect.",
      wrongSecretCode: "Code incorrect. Réessayez.",
    },

    common: {
      back: "Retour",
      cancel: "Annuler",
      confirm: "Confirmer",
      loading: "Chargement…",
    },

    errors: {
      backendNotReady: "Pas encore prêt.",
    },

    official: {
      statusAuthorized: "VÉHICULE AUTORISÉ",
      statusNotAuthorized: "VÉHICULE NON AUTORISÉ",

      // ✅ NEW: Drivers list card (OfficialControlScreen.js)
      driversAssignedTitle: "Chauffeurs affectés à ce véhicule",
      driversEmpty: "Aucun chauffeur enregistré pour ce véhicule.",
      ownersAssignedTitle: "Propriétaires affectés à ce véhicule",
      ownersEmpty: "Aucun propriétaire enregistré pour ce véhicule.",


      vehicle: {
        title: "Identification du véhicule",
        subtitle: "Carte grise",
        plate: "Immatriculation",
        model: "Marque & Modèle",
        owner: "Propriétaire",
      },
      licence: {
        title: "Autorisation d'exercer",
        subtitle: "Licence",
        number: "Numéro de licence",
        validity: "Validité",
        zone: "Zone",
        doorNumber: "Numéro de portière",
      },
      driver: {
        title: "Profil du chauffeur",
        subtitle: "Permis & CNI",
        permit: "Numéro Permis",
        category: "Catégorie",
        cni: "Numéro CNI",
      },
      insurance: {
        title: "Couverture Risques",
        subtitle: "Assurance",
        company: "Compagnie",
        expiry: "Expiration",
        status: "Statut",
      },
    },
  },

  en: {
    lang: {
      fr: "French",
      en: "English",
    },

    home: {
      verified: "Verified",
      notVerified: "Not Verified",
      officialControl: "Official control",
    },

    // ✅ DRIVER (Home + Official Control)
    driver: {
      // Home screen (after scan)
      verified: "Verified",
      notVerified: "Not Verified",
      officialControl: "Official control",

      profileTitle: "Driver profile",
      profileSub: "Licence & ID",
      name: "Driver name",
      permit: "Driver’s licence",
      cni: "National ID",

      // ✅ Aliases used by DriverOfficialControlScreen.js
      capacityTitle: "Operating authorization",
      capacitySub: "Capacity",
      capacityNumber: "Capacity number",
      capacityStatus: "Status",
      capacityNotRegistered: "Not Registered",

      // ✅ EXACT TEXT YOU WANT
      capacityAbsent: "Not provided",

      capacityHelper: "This driver does not have a valid operating authorization.",

      // Official control screen
      official: {
        // Card 1: Driver
        driverTitle: "Driver profile",
        driverSub: "Licence & ID",
        permitNumber: "Licence number",
        permitExpiry: "Licence expiry date",
        permitStatus: "Licence status",

        // Card 2: Capacity
        capacityTitle: "Operating authorization",
        capacitySub: "Capacity",
        capacityNumber: "Capacity number",
        capacityExpiry: "Expiry date",
        capacityStatus: "Status",

        // ✅ Reusable keys (recommended)
        notRegistered: "Not Registered",
        notApplicable: "Not Applicable",

        // ✅ EXACT TEXT YOU WANT
        absent: "Not provided",

        // ✅ Backward-compat keys (keep)
        capacityMissingNumber: "Not Registered",
        capacityMissingExpiry: "Not Applicable",
        capacityAbsentStatus: "Not provided",

        capacityAbsentHelper:
          "This driver does not have a valid operating authorization.",
      },
    },

    modal: {
      enterSecretCode: "Enter Secret code",
      placeholder: "••••••",
      wrongCode: "Wrong code.",
      wrongSecretCode: "Wrong code. Try again.",
    },

    common: {
      back: "Back",
      cancel: "Cancel",
      confirm: "Confirm",
      loading: "Loading…",
    },

    errors: {
      backendNotReady: "Not ready yet.",
    },

    official: {
      statusAuthorized: "AUTHORIZED VEHICLE",
      statusNotAuthorized: "NOT AUTHORIZED",

      // ✅ NEW: Drivers list card (OfficialControlScreen.js)
      driversAssignedTitle: "Drivers assigned to this vehicle",
      driversEmpty: "No driver registered for this vehicle.",
      ownersAssignedTitle: "Owners assigned to this vehicle",
      ownersEmpty: "No owner registered for this vehicle.",


      vehicle: {
        title: "Vehicle identification",
        subtitle: "Registration",
        plate: "Plate number",
        model: "Brand & model",
        owner: "Owner",
      },
      licence: {
        title: "Operating authorization",
        subtitle: "Licence",
        number: "Licence number",
        validity: "Validity",
        zone: "Zone",
        doorNumber: "Door number",
      },
      driver: {
        title: "Driver profile",
        subtitle: "Permit & ID",
        permit: "Permit number",
        category: "Category",
        cni: "ID number",
      },
      insurance: {
        title: "Risk coverage",
        subtitle: "Insurance",
        company: "Company",
        expiry: "Expiry",
        status: "Status",
      },
    },
  },
};

const LanguageContext = createContext(null);

function getByPath(obj, path) {
  return path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), obj);
}

async function storageGet(key) {
  try {
    if (Platform.OS === "web") return window.localStorage.getItem(key);
    return await AsyncStorage.getItem(key);
  } catch {
    return null;
  }
}

async function storageSet(key, value) {
  try {
    if (Platform.OS === "web") window.localStorage.setItem(key, value);
    else await AsyncStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("fr");

  useEffect(() => {
    (async () => {
      const saved = await storageGet(STORAGE_KEY);
      if (saved === "fr" || saved === "en") setLang(saved);
    })();
  }, []);

  useEffect(() => {
    storageSet(STORAGE_KEY, lang);
  }, [lang]);

  const t = useMemo(() => {
    return (key) => {
      const value = getByPath(DICT[lang], key);
      return value ?? key;
    };
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useTranslation() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useTranslation must be used inside <LanguageProvider>");
  return ctx; // { lang, setLang, t }
}
